import React, { lazy, Suspense, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faHandshake, faPersonCirclePlus } from '@fortawesome/free-solid-svg-icons';
import SEOHelmet from '../Component/SEOHelmet';
import Image from '../Component/Home/Image';
import NoDataFull from './NoDataFull';
import axios from 'axios';
import { toast } from 'react-toastify';

const Header = lazy(() => import('../Component/Header'));
const Footer = lazy(() => import('../Component/Footer'));
const Culture = lazy(() => import('../Component/Home/Culture'));

const CultureSection = () => {

    const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const [data, setData] = useState(null);
     const [image, setImage] = useState(null);
     const [video, setVideo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [apiError, setApiError] = useState(false);

    const getData = () => {
        setLoading(true);
        setApiError(false);
        axios.get('https://api.ps-link.world/api/plexus/culture/read2')
            .then((res) => {
                setImage(res.data.data);
                setVideo(res.data.video);
                setLoading(false);
                setApiError(false);
            })
            .catch((err) => {
                console.error(err);
                toast.error("Failed to fetch data.");
                setLoading(false);
                setApiError(true);
            });
    };

    useEffect(() => {
        getData();
    }, []);

    const handleClick = () => {
        window.location.href = '/hiring';
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem('hiringStatus');
        if (storedData) {
            setData(JSON.parse(storedData)); // Parse the JSON string
        }
    }, []);


    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsScrollTopVisible(true);
            } else {
                setIsScrollTopVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const hasimageData = () => {
        if (!image) return false;
        if (Array.isArray(image)) return image.length > 0;
        if (typeof image === 'object') return Object.keys(image).length > 0;
        return true;
    };
    // Show NoDataFull only after loading is complete and either API failed or no data exists
    if (!loading && (apiError || !hasimageData())) {
        return <NoDataFull />;
    }


    return (
        <>
            <SEOHelmet
                title="About Us | Plexus Technology"
                description="Learn more about our innovative IT solutions, software development, and IT consulting services."
                keywords="Tech Experts , Innovative Solutions , Tech Team , Business Solutions , Work Culture , Employee Development , Career Growth , Tech Talent , Plexus Mission , Future Technology , Business Transformation , Global IT Services , About Plexus Technology , Tech Company Overview , Technology Experts at Plexus , Innovative Technology Solutions , IT Solutions Provider , Plexus Technology Team , Tech Solutions for Businesses , Life at Plexus Technology , Employee Culture at Plexus , Work at Plexus Technology , Innovative Work Culture , Career Growth at Plexus , Employee Development Programs , Employee Success at Plexus , Tech Talent at Plexus , Plexus Technology Mission , Future of Technology , Shaping the Future with Technology , Transforming Businesses through Technology , Global IT Services Leader"
                ogTitle="About Us | Plexus Technology"
                ogDescription="Discover how Plexus Technology delivers top-notch IT services to businesses globally."
                ogImage="https://plexus-technology.in/static/media/logo.589291ad7a3760919228.png"
                twitterCard="summary_large_image"
            />

            <Suspense>
                <Header />
                  <div className="culture-bg d-flex align-items-center justify-content-center mt-5" style={{ height: "280px" }}>
                    <h1 className="w-100 h-100 m-0 text-center text-white" style={{ background: 'rgba(0, 0, 0, 45%)', lineHeight: "280px", color: "#132028", fontWeight: "600" }}>Culture</h1>
                </div>
                <Image data={image} loading={loading}/>
                <Culture data={video} loading={loading} />
                <Footer />
            </Suspense>

            <>
                <div className="fixed-button d-flex">
                    <div className="w-auto mx-auto d-flex gap-3 flex-wrap align-items-center justify-content-center">
                        {data === "true" && (
                            <button
                                className="button1"
                                onClick={handleClick}
                            >
                                <FontAwesomeIcon icon={faPersonCirclePlus} className="me-2" />
                                We're Hiring
                            </button>
                        )}

                        <a
                            href="/portfolio"
                            className="button2 text-decoration-none"
                        >
                            <FontAwesomeIcon icon={faHandshake} className="me-2" />
                            Let’s Collaborate
                        </a>
                    </div>
                </div>
            </>

            {isScrollTopVisible && (
                <p className='fixed-top-btn cursor' onClick={scrollToTop}>
                    <FontAwesomeIcon icon={faArrowUp} className='px-2' />
                </p>
            )}
        </>
    );
};

export default CultureSection;